import { Title, tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const StatusWrapper = styled.div`
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${tokens.spacing.insetXsmall};
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
`

export const StepsContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    height: 616px;
    flex: 1;
    min-height: 0;
  }
`

export const StatusOttoWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) rotate(-5.906deg);
  }
`

export const QuittingDescription = styled.div`
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.small};
`

export const EditModeWrapper = styled.div``

export const EditModeTitle = styled(Title)`
  margin-bottom: ${tokens.spacing.verticalXlarge};
`

export const EditModeSelectedEntity = styled.div`
  margin-bottom: ${tokens.spacing.verticalLarge};
`

export const EditModeSelectedEntityLabel = styled.div`
  color: ${tokens.colors.dark3};
  margin-bottom: ${tokens.spacing.verticalSmall};
  font-size: ${tokens.fontSize.small};
`

export const EditModeSelectedEntityInputFake = styled.div`
  display: flex;
  padding: ${tokens.spacing.insetMedium};
  flex-direction: column;
  align-items: flex-start;
  gap: ${tokens.spacing.insetMedium};
  border-radius: ${tokens.radius.large};
  background: ${tokens.colors.dark0};
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
`

export const EditModeGoal = styled.div`
  margin-bottom: ${tokens.spacing.verticalXlarge};
`

export const EditModeGoalLabel = styled.div`
  color: ${tokens.colors.dark4};
  font-size: ${tokens.fontSize.small};
  margin-bottom: ${tokens.spacing.verticalSmall};
`

export const EditModeGoalInputFake = styled.div`
  display: flex;
  padding: ${tokens.spacing.insetMedium};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${tokens.spacing.insetMedium};
  border-radius: ${tokens.radius.large};
  border: 1px solid ${tokens.colors.dark2};
  background: ${tokens.colors.white};
  box-shadow: ${tokens.shadows.downSmall};
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark6};
`
